import MultiSelectFilter from './MultiSelectFilter'

const KIND_OPTIONS = [
  { value: 'testing', label: 'Testing' },
  { value: 'network-performance', label: 'Network Performance' },
  { value: 'react-rendering', label: 'React Rendering' },
  { value: 'layout-shift', label: 'Layout Shift' },
  { value: 'accessibility', label: 'Accessibility' },
  { value: 'glitches', label: 'Glitches' },
  { value: 'user-experience', label: 'User Experience' },
  { value: 'seo', label: 'SEO' },
]

/** The bug-list API's `kind` param: a comma-separated list, or `all` when nothing is selected. */
export function bugKindParam(kinds: string[]): string {
  return kinds.length > 0 ? kinds.join(',') : 'all'
}

interface BugKindFilterProps {
  /** Selected kinds; empty means every kind. */
  value: string[]
  onChange: (value: string[]) => void
}

export default function BugKindFilter({ value, onChange }: BugKindFilterProps) {
  return (
    <MultiSelectFilter
      value={value}
      onChange={onChange}
      options={KIND_OPTIONS}
      label="Kind"
      analyticsPrefix="bug-kind-filter"
      testId="kind-filter"
    />
  )
}
